<template>
  <div
    class="i-favorite-job pad-wrap"
    @click="likeJob"
  >
    <a class="favorite-job">
      <img :src="icon" />
      <div
        class="text"
        :class="{ active: props.isFavorite }"
      >
        {{ text }}
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

import iconStarOutlined from "@/assets/icons/icon-star-black-outline.svg"
import iconStarOrange from "@/assets/icons/icon-star-orange-filled.svg"

import type { Feedback } from "@/shared/types/UserJobFeedback"

// EMITS
const emit = defineEmits(["afterLikeAction"])

// STORES
const reportStore = useReportStore()

// PROPS
const props = defineProps({
  jobId: {
    type: Number,
    required: true
  },
  isFavorite: {
    type: Boolean,
    required: true
  }
})

// COMPUTED
const icon = computed(() => (props.isFavorite ? iconStarOrange : iconStarOutlined))
const text = computed(() => (props.isFavorite ? "Favorited" : "Favorite"))

// FUNCTIONS
const likeJob = () => {
  const feedback = props.isFavorite ? 0 : 2

  handleFeedback(feedback)
  handleFavorite(!props.isFavorite)

  if (!props.isFavorite) emit("afterLikeAction")
}

const handleFavorite = (favorite: boolean) => {
  reportStore.postUserJobFavorite(props.jobId, favorite)
}

const handleFeedback = (feedback: Feedback) => {
  reportStore.postUserJobFeedback(props.jobId, {
    feedback,
    source: "report"
  })
}
</script>

<style scoped lang="scss">
.i-favorite-job {
  .favorite-job {
    @include flex($direction: column, $justify: center, $align: center, $gap: 2px);

    cursor: pointer;
    margin: auto;

    @media screen and (min-width: $breakpoint-sm) {
      flex-direction: row;
      gap: 8px;
    }

    img {
      width: 18px;

      @media screen and (min-width: $breakpoint-sm) {
        align-self: start;
      }
    }

    .text {
      color: $pickle-bluewood900;

      @include text-sm;

      font-weight: 600;

      &.active {
        color: $sorbus500;
      }
    }
  }
}
</style>
